import React from 'react';
import { Link } from 'react-router';
import { ProviderCategory } from '@/api/model/providerCategory';

export const Footer: React.FC = () => {
  return (
    <footer className='border-t bg-white'>
      <div className='container mx-auto px-4 py-10'>
        <div className='grid grid-cols-1 gap-10 md:grid-cols-4'>
          <div className='space-y-4'>
            <div className='flex items-center gap-3'>
              <img src='/logo.png' className='h-10 w-auto' alt='SWD Düren Logo' />
              <span className='sr-only'>SWD Düren</span>
            </div>
            <p className='text-sm text-muted-foreground'>
              Ihr regionaler Energieversorger mit exklusiven Vorteilen für Premium-Kunden.
            </p>
            <div className='flex items-center gap-4 text-muted-foreground'>
              <svg width='12' height='19' viewBox='0 0 12 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <g clip-path='url(#clip0_151_5549)'>
                  <path
                    d='M9.81348 10.875L10.3134 7.61742H7.18766V5.50348C7.18766 4.61227 7.6243 3.74355 9.02422 3.74355H10.4452V0.970078C10.4452 0.970078 9.1557 0.75 7.92277 0.75C5.34863 0.75 3.66605 2.31023 3.66605 5.13469V7.61742H0.804688V10.875H3.66605V18.75H7.18766V10.875H9.81348Z'
                    fill='#72727A'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_151_5549'>
                    <path d='M0 0.75H11.25V18.75H0V0.75Z' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              <svg width='16' height='19' viewBox='0 0 16 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <g clip-path='url(#clip0_151_5554)'>
                  <path
                    d='M8.1292 5.70732C5.89326 5.70732 4.08975 7.51084 4.08975 9.74678C4.08975 11.9827 5.89326 13.7862 8.1292 13.7862C10.3651 13.7862 12.1687 11.9827 12.1687 9.74678C12.1687 7.51084 10.3651 5.70732 8.1292 5.70732ZM8.1292 12.3729C6.68428 12.3729 5.50303 11.1952 5.50303 9.74678C5.50303 8.29834 6.68076 7.12061 8.1292 7.12061C9.57764 7.12061 10.7554 8.29834 10.7554 9.74678C10.7554 11.1952 9.57412 12.3729 8.1292 12.3729ZM13.2761 5.54209C13.2761 6.06592 12.8542 6.48428 12.3339 6.48428C11.8101 6.48428 11.3917 6.0624 11.3917 5.54209C11.3917 5.02178 11.8136 4.5999 12.3339 4.5999C12.8542 4.5999 13.2761 5.02178 13.2761 5.54209ZM15.9515 6.49834C15.8917 5.23623 15.6034 4.11826 14.6788 3.19717C13.7577 2.27607 12.6397 1.98779 11.3776 1.92451C10.0769 1.85068 6.17803 1.85068 4.87725 1.92451C3.61865 1.98428 2.50068 2.27256 1.57607 3.19365C0.651465 4.11475 0.366699 5.23271 0.303418 6.49482C0.22959 7.79561 0.22959 11.6944 0.303418 12.9952C0.363184 14.2573 0.651465 15.3753 1.57607 16.2964C2.50068 17.2175 3.61514 17.5058 4.87725 17.569C6.17803 17.6429 10.0769 17.6429 11.3776 17.569C12.6397 17.5093 13.7577 17.221 14.6788 16.2964C15.5999 15.3753 15.8882 14.2573 15.9515 12.9952C16.0253 11.6944 16.0253 7.79912 15.9515 6.49834ZM14.271 14.3909C13.9968 15.08 13.4659 15.6108 12.7733 15.8886C11.7362 16.2999 9.27529 16.205 8.1292 16.205C6.98311 16.205 4.51865 16.2964 3.48506 15.8886C2.796 15.6144 2.26514 15.0835 1.9874 14.3909C1.57607 13.3538 1.671 10.8929 1.671 9.74678C1.671 8.60068 1.57959 6.13623 1.9874 5.10264C2.26162 4.41357 2.79248 3.88271 3.48506 3.60498C4.52217 3.19365 6.98311 3.28857 8.1292 3.28857C9.27529 3.28857 11.7397 3.19717 12.7733 3.60498C13.4624 3.8792 13.9933 4.41006 14.271 5.10264C14.6823 6.13975 14.5874 8.60068 14.5874 9.74678C14.5874 10.8929 14.6823 13.3573 14.271 14.3909Z'
                    fill='#72727A'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_151_5554'>
                    <path d='M0.25 0.75H16V18.75H0.25V0.75Z' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              <svg width='16' height='19' viewBox='0 0 16 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <g clip-path='url(#clip0_151_5559)'>
                  <path
                    d='M3.52547 16.4996H0.260156V5.98441H3.52547V16.4996ZM1.89105 4.55004C0.846914 4.55004 0 3.6852 0 2.64105C7.47351e-09 2.13952 0.199236 1.65852 0.553877 1.30388C0.908519 0.949236 1.38952 0.75 1.89105 0.75C2.39259 0.75 2.87359 0.949236 3.22823 1.30388C3.58287 1.65852 3.78211 2.13952 3.78211 2.64105C3.78211 3.6852 2.93484 4.55004 1.89105 4.55004ZM15.7465 16.4996H12.4882V11.3809C12.4882 10.161 12.4636 8.59652 10.7905 8.59652C9.09281 8.59652 8.83266 9.92191 8.83266 11.293V16.4996H5.57086V5.98441H8.70258V7.41879H8.74828C9.18422 6.59262 10.2491 5.72074 11.8378 5.72074C15.1425 5.72074 15.75 7.89691 15.75 10.7235V16.4996H15.7465Z'
                    fill='#72727A'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_151_5559'>
                    <path d='M0 0.75H15.75V18.75H0V0.75Z' fill='white' />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>

          <div>
            <h4 className='text-h5 mb-4'>Gutscheine</h4>
            <ul className='space-y-3 text-sm text-muted-foreground'>
              <li>
                <Link to='/vouchers' className='hover:text-foreground transition-colors'>
                  Alle Kategorien
                </Link>
              </li>
              <li>
                <Link
                  to={`/vouchers?category=${ProviderCategory.GASTRONOMIE}`}
                  className='hover:text-foreground transition-colors'
                >
                  Gastronomie
                </Link>
              </li>
              <li>
                <Link
                  to={`/vouchers?category=${ProviderCategory.ERLEBEN}`}
                  className='hover:text-foreground transition-colors'
                >
                  Erleben
                </Link>
              </li>
              <li>
                <Link
                  to={`/vouchers?category=${ProviderCategory.SHOPPING}`}
                  className='hover:text-foreground transition-colors'
                >
                  Shopping
                </Link>
              </li>
              <li>
                <Link
                  to={`/vouchers?category=${ProviderCategory.SERVICES}`}
                  className='hover:text-foreground transition-colors'
                >
                  Services
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className='text-h5 mb-4'>Service</h4>
            <ul className='space-y-3 text-sm text-muted-foreground'>
              <li>
                <Link
                  to='https://www.stadtwerke-dueren.de/privatkunden/service/gutscheinpakete'
                  className='hover:text-foreground transition-colors'
                  target='_blank'
                >
                  Hilfe &amp; FAQ
                </Link>
              </li>
              <li>
                <Link
                  to='https://www.stadtwerke-dueren.de/privatkunden/service/hilfecenter'
                  className='hover:text-foreground transition-colors'
                  target='_blank'
                >
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className='text-h5 mb-4'>Rechtliches</h4>
            <ul className='space-y-3 text-sm text-muted-foreground'>
              <li>
                <Link
                  to='https://www.stadtwerke-dueren.de/ueber-uns/rechtliches/impressum'
                  className='hover:text-foreground transition-colors'
                  target='_blank'
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to='https://www.stadtwerke-dueren.de/ueber-uns/rechtliches/datenschutz'
                  className='hover:text-foreground transition-colors'
                  target='_blank'
                >
                  Datenschutz
                </Link>
              </li>

              <li>
                <Link
                  to='https://www.stadtwerke-dueren.de/ueber-uns/rechtliches/agb'
                  className='hover:text-foreground transition-colors'
                >
                  AGB
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className='mt-10 border-t pt-6 text-sm text-muted-foreground'>
          <div className='flex flex-col items-start justify-between gap-4 md:flex-row md:items-center'>
            <p>© 2025 Stadtwerke Düren GmbH. Alle Rechte vorbehalten.</p>
            <p>Powered by SWD</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
